import { render, staticRenderFns } from "./IconSettingsApi.vue?vue&type=template&id=29f17aa1&"
import script from "./IconSettingsApi.vue?vue&type=script&lang=js&"
export * from "./IconSettingsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f17aa1')) {
      api.createRecord('29f17aa1', component.options)
    } else {
      api.reload('29f17aa1', component.options)
    }
    module.hot.accept("./IconSettingsApi.vue?vue&type=template&id=29f17aa1&", function () {
      api.rerender('29f17aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsApi.vue"
export default component.exports